import TooltipLink, {
  type TooltipLinkProps,
} from "@/v2-backoffice-client/components/link/TooltipLink"
import config from "@/v2-backoffice-client/config"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import { isFusionLoginIdentity } from "@/v2-backoffice-client/user/identity/userIdentity.constants"

const USER_PORTAL_BLADE =
  "#view/Microsoft_AAD_UsersAndTenants/UserProfileMenuBlade/~/overview/userId"

export const USER_ENTRA_BASE_URL = `https://portal.azure.com/${USER_PORTAL_BLADE}`

// Tenant-less legacy form: opens in whatever directory the operator's
// portal session holds. Kept for call sites without a full user fragment
// (create-phase results/conflicts).
export function getUserEntraUrl(azureId: string) {
  return `${USER_ENTRA_BASE_URL}/${azureId}`
}

// Tenant-aware form (FUS-927): deep-links the directory that OWNS the
// user's sign-in — the External ID tenant + EntraId oid for Fusion-login
// users (a migrated user's legacy AzureID addresses nothing there),
// legacy B2C otherwise.
export function getUserDirectoryPortalUrl(
  user: Pick<UserFragment, "AzureID" | "EntraId" | "IdentitySyncStatus">,
) {
  const fusion = isFusionLoginIdentity(user.IdentitySyncStatus)
  const tenantDomain = fusion
    ? config.entraTenantDomain
    : config.b2cTenantDomain
  const oid = fusion ? (user.EntraId ?? user.AzureID) : user.AzureID
  return `https://portal.azure.com/${tenantDomain}${USER_PORTAL_BLADE}/${oid}`
}

export type UserEntraButtonProps = Omit<TooltipLinkProps, "to"> & {
  azureId: string | null | undefined
}

function UserEntraButton(props: UserEntraButtonProps) {
  const { azureId, ...tooltipLinkProps } = props
  return (
    <TooltipLink
      to={azureId ? getUserEntraUrl(azureId) : undefined}
      variant="ghost"
      size="tiny"
      iconSrc="entra"
      content="Open in Entra"
      disabled={!azureId}
      {...tooltipLinkProps}
    />
  )
}

export default UserEntraButton
